(function() {
    'use strict';

    angular.module('bbw.GuestApplication', ['bbw', 'ngAnimate']).
        constant('BBW_APP', 'guest').
        directive('bbwSignin', bbw.directive.bbwSignin).
        directive('bbwSigninModal', bbw.directive.bbwSigninModal).
        service('bbw.RegisterUserSvc', bbw.service.RegisterUserSvc).
        controller('LayoutCtrl', bbw.shared.LayoutCtrl).
        controller('ProfileCtrl', bbw.guest.ProfileCtrl).
        controller('PhotoAlbumPublicCtrl', bbw.guest.PhotoAlbumPublicCtrl).
        controller('SearchCtrl', bbw.shared.SearchCtrl).
        controller('HomeSearchCtrl', bbw.shared.HomeSearchCtrl).
        controller('PageCtrl', bbw.shared.PageCtrl).
        controller('PasswordResetRequestCtrl', bbw.guest.PasswordResetRequestCtrl).
        controller('PasswordResetCtrl', bbw.shared.PasswordResetCtrl).
        controller('AdminLoginCtrl', bbw.guest.AdminLoginCtrl).
        component('bbwSignup', bbw.guest.SignupComponent);
})();
